import {Component} from "@angular/core";

@Component({
  selector: 'fabric8-pipelines-list-toolbar',
  templateUrl: './list-toolbar.pipeline.component.html',
  styleUrls: ['./list-toolbar.pipeline.component.scss'],
})
export class PipelinesListToolbarComponent {

}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
